import React, { FC, ReactNode } from "react";
import { Icon, IconName } from "../icon";

import "./alert.css";

interface IAlertProps {
	iconName: IconName;
	children?: ReactNode;
}

export const Alert: FC<IAlertProps> = ({ iconName, children }) => {
	return (
		<div className="alert">
			<Icon iconName={iconName} />
			{children}
		</div>
	);
};
